export default (function productInit() {
  const product = {
    getDate() {
      const activeItem = $('.dropdown__menu_item.dropdown__menu_item--active'); // Get the active item
      let id_second_attribute = 0; // Default value is 0
      if (activeItem.length > 0 && activeItem.find('.attribute_radio').val()) {
        // If the active item exists and contains data-ff_calc_id_combination attribute
        id_second_attribute = activeItem.find('.attribute_radio').val();
      }
      const data = {
        id_product: $('#product_page_product_id').val(),
        action: 'getDates',
        id_attribute: $('.js--date .attribute_radio:checked').val(),
        id_lang: id_lang,
        id_second_attribute: id_second_attribute
      };
      $.ajax({
        url: '/modules/ffcalc/ajax.php',
        type: 'POST',
        dataType: 'json',
        data,
        success: (response) => {
          $('.js--date').removeClass('disabled');
          $('.js--date').after($.parseHTML(response.template))
        }
      })

    },

    dropdownTabs() {
      const $dropdownTabs = $('.product .dropdown');
      $dropdownTabs.on('hide.bs.dropdown', function (e) {
        if (e.clickEvent !== undefined) {
          if ($(e.clickEvent.target).closest('.dropdown__menu:not(.housing_choice__menu)').length > 0) {
            e.preventDefault();
          }
        }
      });
    },
    toggleActiveAttr() {
      // $('.housing_choice .attribute_radio:checked').closest('.js--dropdown__switch_text').click();
      $(document).on('click', '.js--attr_product', function () {
        $('.js--attr_product').removeClass('active');
        $(this).addClass('active')
      })
    },
    observeChange() {
      const children = document.getElementsByClassName('js--children');
      const guests = document.getElementsByClassName('js--guests');
      const config = {
        childList: true,
      };

      if (children.length && guests.length) {
        const callback = function (mutationsList) {
          const $observeElem = $(mutationsList[0].target);
          product.declOfNum($observeElem);
        };
        const observer = new MutationObserver(callback);
        observer.observe(children[0], config);
        observer.observe(guests[0], config);
      }
    },
    declOfNum($elem) {
      const textArray = $elem.data('text');
      const number = Number($elem.text());
      const cases = [2, 0, 1, 1, 1, 2];
      const currentText = textArray[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
      $elem.next('.js--all_count_text').text(currentText)

    },
  };
  $(document).ready(function () {
    if($('body').hasClass('product')){

    product.getDate();
    product.dropdownTabs();
    product.toggleActiveAttr();
    product.observeChange();
    }
  })
})()
